// Generated by Copilot- Start
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "../../video-lab/dtv-text";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import { absoluteLinkUrl, getLinkClickAttrs, modalLinkPosition, usePageUrl } from "src/utils/link-click";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

export interface PackageInfoCtaV2Props {
  packageEntry: {
    id: string;
    displayLabel: string;
    packageLegal: string;
    ctaObj: any;
    type: string;
  };
  channelName: string;
  channelCategory: string;
  index: number;
  ctaOnly?: boolean; // When true, only show CTA button without package info
}

function PackageInfoCtaV2(props: PackageInfoCtaV2Props) {
  // WAT-12738 (AC7/AC8): the CTA reports the modal it sits in (same id as the modal close
  // X) and an absolute destination (was the relative ctaUrl).
  const pageUrl = usePageUrl();
  const ctaAttrs = getLinkClickAttrs(
    `${props?.packageEntry?.ctaObj?.cta || ""} ${props?.packageEntry?.id || ""}`,
    modalLinkPosition(`${props?.channelCategory}_${props?.channelName}`),
    absoluteLinkUrl(props?.packageEntry?.ctaObj?.ctaUrl, pageUrl)
  );
  try {
    const { packageEntry, index, ctaOnly = false } = props;
    const { id, displayLabel, packageLegal, ctaObj } = packageEntry;

    // If ctaOnly mode, just return the button
    if (ctaOnly) {
      return ctaObj?.cta ? (
        <DtvButton
          ariaLabel={ctaObj.ctaAccessibility || ctaObj.cta}
          color="primary"
          data-testid="package-cta-button-v2"
          googleAnalyticsData={ctaAttrs}
          key={index}
          label={ctaObj.cta}
          mode="dark"
          targeturl={ctaObj.ctaUrl}
          variant="uxprimary"
          ga4Analytics={{
            item_id: id,
            item_name: ctaObj.cta,
            index
          }}
          sx={{
            height: {
 xs: "36px",
sm: "43px",
md: "48px"
},
            width: "auto",
            fontSize: {
 xs: "14px",
md: "16px",
xl: "16px"
}
          }}
        />
      ) : null;
    }

    return (
      <DtvBox
        id="package-cta-v2"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          justifyContent: {
 xs: "space-between",
sm: "flex-start"
}
        }}
      >
        <DtvBox sx={{
 minWidth: {
 xs: "224px",
sm: "310px"
}
}}>
          <DtvText content={displayLabel} sx={{ fontSize: "20px !important" }} variant="body1medium" />
          <DtvBox sx={{
 display: "flex",
alignItems: "center",
maxWidth: "280px"
}}>
            <DtvText
              content={packageLegal}
              variant="body2"
              sx={{
                fontSize: "16px !important",
                textAlign: "left",
                display: "inline-block"
              }}
            />
          </DtvBox>
        </DtvBox>

        {ctaObj?.cta && (
          <DtvBox sx={{
 display: "flex",
alignItems: "center"
}}>
            <DtvButton
              ariaLabel={ctaObj.ctaAccessibility || ctaObj.cta}
              data-testid="package-cta-button-v2"
              key={index}
              targeturl={ctaObj.ctaUrl}
              variant="uxprimary"
              ga4Analytics={{
                item_id: id,
                item_name: ctaObj.cta,
                index
              }}
              googleAnalyticsData={ctaAttrs}
              label={<DtvText content={ctaObj.cta} variant="body2medium" sx={{
 px: "4px",
fontSize: "14px !important"
}} />}
              sx={{
                height: "36px",
                width: "auto",
                padding: "0px 16px !important"
              }}
            />
          </DtvBox>
        )}
      </DtvBox>
    );
  } catch (error) {
    console.error("Error in PackageInfoCtaV2 >> ", error);
    return <ErrorDisplay component="Package Info CTA V2" error={error} />;
  }
}

export default React.memo(PackageInfoCtaV2);
// Generated by Copilot- End
